import { render, staticRenderFns } from "./circular-spinner.vue?vue&type=template&id=aab9963e"
import script from "./circular-spinner.vue?vue&type=script&lang=js"
export * from "./circular-spinner.vue?vue&type=script&lang=js"
import style0 from "./circular-spinner.vue?vue&type=style&index=0&id=aab9963e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aab9963e')) {
      api.createRecord('aab9963e', component.options)
    } else {
      api.reload('aab9963e', component.options)
    }
    module.hot.accept("./circular-spinner.vue?vue&type=template&id=aab9963e", function () {
      api.rerender('aab9963e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/circular-spinner.vue"
export default component.exports